import React from 'react'
import PropTypes from 'prop-types'
import createReactClass from 'create-react-class'
import s from './loader.module.scss'

export default createReactClass({
  displayName: 'Loader',

  propTypes: {
    children: PropTypes.node,
  },

  childContextTypes: {
    loader: PropTypes.object,
  },

  statics: {
    wrapPromise(promise, loader) {
      loader.show()

      return promise
        .then((result) => {
          loader.hide()

          return Promise.resolve(result)
        })
        .catch((error) => {
          loader.hide()

          return Promise.reject(error)
        })
    },
  },

  getChildContext() {
    return {
      loader: {
        show: this.showLoader,
        hide: this.hideLoader,
        isLoading: this.state.loading,
      },
    }
  },

  getInitialState() {
    return {
      loading: false,
    }
  },

  loaderMsToShow: 5,
  showTimer: null,
  hideTimer: null,
  timerQueue: null,

  showLoader() {
    if (this.hideTimer) {
      // Only clear hide timer
      clearTimeout(this.hideTimer)
      this.hideTimer = null
      return
    }

    if (this.state.loading || this.showTimer) {
      this.timerQueue += 1
      return
    }

    const show = () => {
      this.showTimer = null
      this.setState({ loading: true })
    }

    this.showTimer = setTimeout(show, this.loaderMsToShow)
  },

  hideLoader() {
    if (this.showTimer) {
      // Only clear show timer
      clearTimeout(this.showTimer)
      this.showTimer = null
      return
    }

    if (this.timerQueue) {
      this.timerQueue -= 1
      return
    }

    const hide = () => {
      this.hideTimer = null
      this.setState({ loading: false })
    }

    this.hideTimer = setTimeout(hide, this.loaderMsToShow)
  },

  render() {
    return (
      <>
        {this.state.loading ? (
          <div className={s.wrapper}>
            <div className={s.loader} />
          </div>
        ) : null}
        {this.props.children}
      </>
    )
  },
})
